import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { IStore } from '../../store/types'
import { SearchWorkspace } from '../../components/SearchWorkspace'
import { useAppDispatch } from '../../store'
import { searchChats } from '../../store/searchChatsSales/actions'
import { STATUSES_CHAT_SALES } from '../../utils/consts'
import { ROUTES } from '../../utils/routes'

export const SearchChatSales: React.FC = () => {
  const { searchChatsSales } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!searchChatsSales.data) {
      dispatch(searchChats({}))
    }
  }, [searchChatsSales.data])

  const handleChangePage = (page: number) => {
    if (!searchChatsSales.data) return null
    if (searchChatsSales.data.pages >= page) {
      dispatch(searchChats({ ...searchChatsSales.searchFields, page }))
    }
  }

  const handleGetDialog = (dialogId: number) => {
    navigate(ROUTES.changeSearch(dialogId))
  }

  return (
    <SearchWorkspace
      types={STATUSES_CHAT_SALES}
      data={searchChatsSales.data}
      changePage={handleChangePage}
      getDialog={handleGetDialog}
    />
  )
}
